var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 10.4167H13.7034V14.1667H9.99967V10.4167ZM15.1849 3.66669H14.4441V2.16669H12.9626V3.66669H7.03671V2.16669H5.55523V3.66669H4.81449C3.99967 3.66669 3.33301 4.34169 3.33301 5.16669V15.6667C3.33301 16.4917 3.99967 17.1667 4.81449 17.1667H15.1849C15.9997 17.1667 16.6663 16.4917 16.6663 15.6667V5.16669C16.6663 4.34169 15.9997 3.66669 15.1849 3.66669ZM15.1849 5.16669V6.66669H4.81449V5.16669H15.1849ZM4.81449 15.6667V8.16669H15.1849V15.6667H4.81449Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8e72e9c9981b57155c3f0fbb6ce8781c.svg";
export { ForwardRef as ReactComponent };